<template>
    <div class="mtg-agents-block__body">
        <div class="mtg-agents-block__head g-text__p _gray g_semibold">Документы</div>
        <div class="mtg-agents-block__docs">
            <a
                v-for="doc in data.data"
                :key="`doc-${doc.id}`"
                class="mtg-agents-block__doc u-link__download"
                :href="doc.props && doc.props.file ? doc.props.file.src : '#!'"
                target="_blank"
            >
                <span class="u-link__download-text g_medium">{{ doc.name }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MortAgentsDocs',
    props: {
        data: {
            type: Object,
            default () {
                return [];
            }
        }
    }
};
</script>
